<template>
  <div class="auth-main v1">
    <div class="auth-wrapper">
      <div class="auth-form">
        <div class="card my-5">
          <div class="card-body">
            <div class="text-center">
              <img src="/src/assets/images/logo/vesproc120.png" alt="VESPROC" class="img-fluid mb-3" />
              <div class="auth-status-icon bg-light-primary text-primary mx-auto mb-3">
                <i class="ph-duotone ph-envelope-simple-open"></i>
              </div>
              <h4 class="f-w-500 mb-2">{{ $t('auth.checkEmail.title') }}</h4>
              <p v-if="email" class="mb-1">
                {{ $t('auth.checkEmail.sentTo') }}
                <strong class="d-block text-break">{{ email }}</strong>
              </p>
              <p v-else class="mb-1">{{ $t('auth.checkEmail.sentToYou') }}</p>
              <p class="text-muted mb-4">{{ $t('auth.checkEmail.instructions') }}</p>
            </div>

            <div v-if="error" class="alert alert-danger alert-dismissible fade show" role="alert">
              {{ error }}
              <button type="button" class="btn-close" :aria-label="$t('common.close')" @click="error = null"></button>
            </div>
            <div v-if="resent" class="alert alert-success" role="status">
              {{ $t('common.notification.resendVerificationSuccess') }}
            </div>

            <div class="d-grid">
              <router-link :to="{ name: 'Login' }" class="btn btn-primary">
                {{ $t('auth.emailVerification.goToLogin') }}
              </router-link>
            </div>

            <!-- Resending needs the address, which only the registration form hands over. -->
            <p v-if="email" class="text-center text-muted mt-3 mb-0">
              {{ $t('auth.login.didntReceiveEmail') }}
              <button
                type="button"
                class="btn btn-link link-primary p-0 ms-1 align-baseline"
                :disabled="loading"
                @click="resend"
              >
                <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
                {{ $t('auth.login.resendVerification') }}
              </button>
            </p>
            <p class="text-center text-muted small mt-2 mb-0">{{ $t('auth.checkEmail.spamHint') }}</p>
          </div>
        </div>
      </div>
      <AuthFooter />
    </div>
  </div>
</template>

<script setup>
// 1. Vue core
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

// 3. Services
import authService from '@/services/authService'

// 4. Components
import AuthFooter from '@/components/auth/AuthFooter.vue'

const { t } = useI18n()

// The registration form passes the address in history state rather than the URL, so it
// stays out of logs and shared links but survives a reload of this page.
const email = ref(window.history.state?.email || '')

const loading = ref(false)
const error = ref(null)
const resent = ref(false)

const resend = async () => {
  loading.value = true
  error.value = null
  resent.value = false
  try {
    await authService.resendEmailVerification(email.value)
    resent.value = true
  } catch (err) {
    // The API explains a cooldown ("wait N minutes") in the UI language.
    error.value = err.response?.data?.error?.message || err.response?.data?.message ||
      t('common.notification.resendVerificationError')
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.auth-main.v1 {
  background-color: #f2f2f2;
  background-image: url('/src/assets/images/logo/worldmap.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.auth-status-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
}
</style>
